<template>
  <div class=" transfer-list">
    <div class="transfer-list__header">
      <t-checkbox
        ref="allCheck"
        :value="checkedAll"
        :disabled="checkedAllDisabled"
        :size="size"
        :indeterminate="isIndeterminate"
        class="form-transfer-list__header-title"
        @on-change="$_onAllCheckboxChange">{{ count + title }}</t-checkbox>
    </div>
    <div v-if="filterable" class="transfer-list__searcher">
      <t-input v-model.trim="searchQuery" :placeholder="filterPlaceholder" size="sm" icon="magnify">
      </t-input>
    </div>
    <ul class="transfer-list__body list-unstyled">
      <li v-for="entry in filteredDatas" :key="entry.key">
        <t-checkbox
          :disabled="entry.disabled"
          :value="$_isCheck(entry)"
          :size="size"
          class="transfer-list__text"
          @on-change="$_onCheckboxChange(entry)"><list-content :disabled="entry.disabled" :item="entry"></list-content></t-checkbox>
      </li>
      <li v-if="!filteredDatas.length" class="transfer-list__not-found">
        {{ notFoundText }}
      </li>
    </ul>
    <div v-if="showFooter" ref="list-footer" class="transfer-list__footer">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import TCheckbox from '../checkbox/checkbox.vue'
export default {
  name: 'TList',
  components: {
    TCheckbox,
    ListContent: {
      props: {
        item: {
          required: true
        }
      },
      render: function(createElement) {
        const parent = this.$parent.$parent
        const item = this.item
        return parent.renderContent ? createElement('span', {}, [
          parent.renderContent(createElement, item)
        ]) : createElement(
          'span', {
            attrs: {
              title: item.label
            }
          },
          item.label
        )
      }
    }
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    filterable: Boolean,
    showFooter: Boolean,
    type: String, // 内容是树组件还是box group组件
    title: [String, Number],
    filterPlaceholder: String,
    filterMethod: {
      type: Function,
      default(data, query) {
        if (data) {
          const type = 'label' in data ? 'label' : 'key'
          return (data[type] + '').indexOf(query) > -1
        } else {
          return false
        }
      }
    },
    notFoundText: String,
    direction: String,
    size: {
      type: String,
      validator(value) {
        return ['', 'sm'].includes(value)
      }
    },
    checkedKey: {
      type: Array,
      default: () => []
    },
    renderContent: Function
  },
  data() {
    return {
      searchQuery: '',
      checkedKeys: this.checkedKey.length ? this.checkedKey : [],
      filteredDatas: []
    }
  },
  computed: {
    count: function() {
      const validKeysCount = this.checkedKeys.length
      return (
        (validKeysCount > 0 ? `${validKeysCount}/` : '') + `${this.data.length}`
      )
    },
    checkedAll: function() {
      const validKeysCount = this.checkedKeys.length
      return (
        this.data.filter(data => !data.disabled).length === validKeysCount &&
        validKeysCount !== 0
      )
    },
    checkedAllDisabled: function() {
      return this.data.filter(data => !data.disabled).length <= 0
    },
    isIndeterminate: function() {
      return (
        this.checkedKeys.length > 0 &&
        this.checkedKeys.length < this.data.length
      )
    }
  },
  watch: {
    data: function() {
      this.$_updateFilteredData()
    },
    checkedKeys: function(newVal) {
      if (this.$parent && this.$parent.$refs) {
        this.$parent.$refs.operation[this.direction + 'Active'] = !!newVal.length
      }
      if (newVal.toString() !== this.checkedKey.toString() && this.$parent) {
        this.$parent.handleCheckedKeysChange(this.direction, newVal)
      }
    },
    checkedKey(newVal) {
      this.checkedKeys = newVal && newVal.length ? newVal : []
      this.$_updateFilteredData()
    },
    searchQuery(newVal) {
      this.$_updateFilteredData()
    }
  },
  created: function() {
    this.$_updateFilteredData()
  },
  mounted() {
    const flag = this.checkedKeys.length > 0
    if (this.$parent && this.$parent.$refs) {
      this.$parent.$refs.operation[this.direction + 'Active'] = flag
    }
  },
  methods: {
    $_isCheck: function(item) {
      return this.checkedKeys.includes(item.key)
    },
    $_onCheckboxChange: function(item) {
      if (this.$_isCheck(item)) {
        this.checkedKeys = this.checkedKeys.filter(key => key !== item.key)
      } else {
        this.checkedKeys.push(item.key)
      }
    },
    checkAll(isChecked) {
      if (isChecked === undefined) {
        isChecked = !this.$refs.allCheck.checked
      }
      this.checkedKeys = isChecked ? this.data.filter(
        data => !data.disabled || this.checkedKeys.indexOf(data.key) > -1
      ).map(data => data.key) : this.data.filter(
        data => data.disabled && this.checkedKeys.indexOf(data.key) > -1
      ).map(data => data.key)
    },
    $_onAllCheckboxChange: function(isChecked) {
      this.checkAll(isChecked)
    },
    select: function(item) {
      if (!item || item.disabled) return
      const index = this.checkedKeys.indexOf(item.key)
      index > -1
        ? this.checkedKeys.splice(index, 1)
        : this.checkedKeys.push(item.key)
    },
    $_updateFilteredData: function() {
      this.filteredDatas = this.$getFilterData()
    },
    $_filterData: function(value) {
      return this.filterMethod(value, this.searchQuery)
    },
    $getFilterData () {
      if (!this.data) {
        return []
      }
      return this.data.filter(dataItem => {
        return this.$_filterData(dataItem)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// list.vue?076ca276